import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "about-page" }
const _hoisted_4 = { class: "text-layout" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "mini-projects-grid" }
const _hoisted_9 = { class: "mp-header" }
const _hoisted_10 = { class: "mp-header" }
const _hoisted_11 = { class: "mp-header" }
const _hoisted_12 = { class: "mp-header" }
const _hoisted_13 = { class: "mp-header" }
const _hoisted_14 = { class: "mp-header" }
const _hoisted_15 = { class: "mp-header" }
const _hoisted_16 = { class: "text-layout" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_AboutContentBlock = _resolveComponent("AboutContentBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_AboutContentBlock, {
          icon: "mdi-account-school-outline",
          title: _ctx.$t('about.title'),
          variant: "teal"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", {
                innerHTML: _ctx.$t('about.intro1')
              }, null, 8, _hoisted_5),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('about.intro2')
              }, null, 8, _hoisted_6),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('about.intro3')
              }, null, 8, _hoisted_7)
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_AboutContentBlock, {
          icon: "mdi-rocket-launch-outline",
          title: _ctx.$t('about.projectsTitle'),
          variant: "terracotta"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.trackMiniProjectClick('infrastructure'))),
                class: "mini-project-card",
                role: "button"
              }, [
                _createElementVNode("div", _hoisted_9, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "mdi mdi-server-network" }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.projects.homelab.title')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.projects.homelab.desc')), 1),
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "mp-tags" }, [
                  _createElementVNode("span", null, "K3s"),
                  _createElementVNode("span", null, "ArgoCD"),
                  _createElementVNode("span", null, "Proxmox")
                ], -1))
              ]),
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.trackMiniProjectClick('ndi'))),
                class: "mini-project-card",
                role: "button"
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _cache[9] || (_cache[9] = _createElementVNode("span", { class: "mdi mdi-timer-outline" }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.projects.ndi.title')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.projects.ndi.desc')), 1),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mp-tags" }, [
                  _createElementVNode("span", null, "Next.js"),
                  _createElementVNode("span", null, "Spring Boot"),
                  _createElementVNode("span", null, "OpenAPI")
                ], -1))
              ]),
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.trackMiniProjectClick('portfolio'))),
                class: "mini-project-card",
                role: "button"
              }, [
                _createElementVNode("div", _hoisted_11, [
                  _cache[11] || (_cache[11] = _createElementVNode("span", { class: "mdi mdi-application-cog-outline" }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.projects.portfolio.title')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.projects.portfolio.desc')), 1),
                _cache[12] || (_cache[12] = _createElementVNode("div", { class: "mp-tags" }, [
                  _createElementVNode("span", null, "GitLab CI"),
                  _createElementVNode("span", null, "ArgoCD"),
                  _createElementVNode("span", null, "K8s")
                ], -1))
              ]),
              _createElementVNode("div", {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.trackMiniProjectClick('pikuTrade'))),
                class: "mini-project-card",
                role: "button"
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "mdi mdi-chart-line" }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.projects.pikutrade.title')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.projects.pikutrade.desc')), 1),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "mp-tags" }, [
                  _createElementVNode("span", null, "Java"),
                  _createElementVNode("span", null, "WebFlux"),
                  _createElementVNode("span", null, "DeepLearning")
                ], -1))
              ]),
              _createElementVNode("div", {
                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.trackMiniProjectClick('sproogy'))),
                class: "mini-project-card",
                role: "button"
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "mdi mdi-xml" }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.projects.sproogy.title')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.projects.sproogy.desc')), 1),
                _cache[16] || (_cache[16] = _createElementVNode("div", { class: "mp-tags" }, [
                  _createElementVNode("span", null, "Java"),
                  _createElementVNode("span", null, "Security"),
                  _createElementVNode("span", null, "Reflection")
                ], -1))
              ]),
              _createElementVNode("div", {
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.trackMiniProjectClick('referendum'))),
                class: "mini-project-card",
                role: "button"
              }, [
                _createElementVNode("div", _hoisted_14, [
                  _cache[17] || (_cache[17] = _createElementVNode("span", { class: "mdi mdi-vote-outline" }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.projects.referendum.title')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.projects.referendum.desc')), 1),
                _cache[18] || (_cache[18] = _createElementVNode("div", { class: "mp-tags" }, [
                  _createElementVNode("span", null, "ElGamal"),
                  _createElementVNode("span", null, "SOLID"),
                  _createElementVNode("span", null, "Java")
                ], -1))
              ]),
              _createElementVNode("div", {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.trackMiniProjectClick('cgj'))),
                class: "mini-project-card",
                role: "button"
              }, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[19] || (_cache[19] = _createElementVNode("span", { class: "mdi mdi-controller-classic-outline" }, null, -1)),
                  _createElementVNode("strong", null, _toDisplayString(_ctx.$t('about.projects.cgj.title')), 1)
                ]),
                _createElementVNode("p", null, _toDisplayString(_ctx.$t('about.projects.cgj.desc')), 1),
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "mp-tags" }, [
                  _createElementVNode("span", null, "Agile"),
                  _createElementVNode("span", null, "Git"),
                  _createElementVNode("span", null, "GameDev")
                ], -1))
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_AboutContentBlock, {
          icon: "mdi-shield-check-outline",
          title: _ctx.$t('about.skillsTitle'),
          variant: "stone"
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createElementVNode("div", { class: "skills-showcase" }, [
              _createElementVNode("div", { class: "skill-box" }, [
                _createElementVNode("div", { class: "sb-header" }, [
                  _createElementVNode("span", { class: "mdi mdi-cloud-sync" }),
                  _createElementVNode("h3", null, "Infra & DevOps")
                ]),
                _createElementVNode("div", { class: "sb-pills" }, [
                  _createElementVNode("span", { class: "pill" }, "Kubernetes"),
                  _createElementVNode("span", { class: "pill" }, "GitOps"),
                  _createElementVNode("span", { class: "pill" }, "Terraform"),
                  _createElementVNode("span", { class: "pill" }, "Proxmox")
                ])
              ]),
              _createElementVNode("div", { class: "skill-box" }, [
                _createElementVNode("div", { class: "sb-header" }, [
                  _createElementVNode("span", { class: "mdi mdi-code-braces" }),
                  _createElementVNode("h3", null, "Backend Dev")
                ]),
                _createElementVNode("div", { class: "sb-pills" }, [
                  _createElementVNode("span", { class: "pill" }, "Java 21"),
                  _createElementVNode("span", { class: "pill" }, "Spring Boot"),
                  _createElementVNode("span", { class: "pill" }, "WebFlux"),
                  _createElementVNode("span", { class: "pill" }, "REST/GraphQL")
                ])
              ]),
              _createElementVNode("div", { class: "skill-box" }, [
                _createElementVNode("div", { class: "sb-header" }, [
                  _createElementVNode("span", { class: "mdi mdi-database-cog-outline" }),
                  _createElementVNode("h3", null, "Cloud Storage")
                ]),
                _createElementVNode("div", { class: "sb-pills" }, [
                  _createElementVNode("span", { class: "pill" }, "Longhorn CSI"),
                  _createElementVNode("span", { class: "pill" }, "MinIO (S3)"),
                  _createElementVNode("span", { class: "pill" }, "ZFS"),
                  _createElementVNode("span", { class: "pill" }, "PostgreSQL HA")
                ])
              ]),
              _createElementVNode("div", { class: "skill-box" }, [
                _createElementVNode("div", { class: "sb-header" }, [
                  _createElementVNode("span", { class: "mdi mdi-security" }),
                  _createElementVNode("h3", null, "SecOps")
                ]),
                _createElementVNode("div", { class: "sb-pills" }, [
                  _createElementVNode("span", { class: "pill" }, "HashiCorp Vault"),
                  _createElementVNode("span", { class: "pill" }, "Zitadel SSO"),
                  _createElementVNode("span", { class: "pill" }, "NetPolicies"),
                  _createElementVNode("span", { class: "pill" }, "RBAC")
                ])
              ]),
              _createElementVNode("div", { class: "skill-box" }, [
                _createElementVNode("div", { class: "sb-header" }, [
                  _createElementVNode("span", { class: "mdi mdi-chart-bell-curve-cumulative" }),
                  _createElementVNode("h3", null, "Observability")
                ]),
                _createElementVNode("div", { class: "sb-pills" }, [
                  _createElementVNode("span", { class: "pill" }, "Prometheus"),
                  _createElementVNode("span", { class: "pill" }, "Grafana"),
                  _createElementVNode("span", { class: "pill" }, "Loki"),
                  _createElementVNode("span", { class: "pill" }, "Alertmanager")
                ])
              ]),
              _createElementVNode("div", { class: "skill-box" }, [
                _createElementVNode("div", { class: "sb-header" }, [
                  _createElementVNode("span", { class: "mdi mdi-palette-swatch-outline" }),
                  _createElementVNode("h3", null, "Frontend / UI")
                ]),
                _createElementVNode("div", { class: "sb-pills" }, [
                  _createElementVNode("span", { class: "pill" }, "Vue.js 3"),
                  _createElementVNode("span", { class: "pill" }, "TypeScript"),
                  _createElementVNode("span", { class: "pill" }, "Vite"),
                  _createElementVNode("span", { class: "pill" }, "CSS (LN Theme)")
                ])
              ])
            ], -1)
          ])),
          _: 1
        }, 8, ["title"]),
        _createVNode(_component_AboutContentBlock, {
          icon: "mdi-map-marker-distance",
          title: _ctx.$t('about.futureTitle'),
          variant: "beige"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("p", {
                innerHTML: _ctx.$t('about.future1')
              }, null, 8, _hoisted_17),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('about.future2')
              }, null, 8, _hoisted_18),
              _createElementVNode("p", {
                innerHTML: _ctx.$t('about.future3')
              }, null, 8, _hoisted_19)
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ])
    ])
  ]))
}